const pad2 = (num: number) => String(num).padStart(2, "0");

const updateCountdown = (holder: HTMLElement, targetDate: Date) => {
  const daysEl = holder.querySelector<HTMLElement>("[data-days]");
  const hoursEl = holder.querySelector<HTMLElement>("[data-hours]");
  const minutesEl = holder.querySelector<HTMLElement>("[data-minutes]");
  const secondsEl = holder.querySelector<HTMLElement>("[data-seconds]");
  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return false;

  const diffMs = targetDate.getTime() - Date.now();
  if (diffMs <= 0) {
    daysEl.textContent = "00";
    hoursEl.textContent = "00";
    minutesEl.textContent = "00";
    secondsEl.textContent = "00";
    return false;
  }

  const totalSeconds = Math.floor(diffMs / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  daysEl.textContent = pad2(days);
  hoursEl.textContent = pad2(hours);
  minutesEl.textContent = pad2(minutes);
  secondsEl.textContent = pad2(seconds);
  return true;
};

const initHolder = (holder: HTMLElement) => {
  if (holder.dataset.ekCountdownInitialized === "true") return;

  const targetStr = holder.dataset.target;
  if (!targetStr) return;

  const targetDate = new Date(targetStr);
  if (Number.isNaN(targetDate.getTime())) return;

  const isActive = updateCountdown(holder, targetDate);
  holder.dataset.ekCountdownInitialized = "true";
  if (!isActive) return;

  const intervalId = window.setInterval(() => {
    const shouldContinue = updateCountdown(holder, targetDate);
    if (shouldContinue) return;
    window.clearInterval(intervalId);
  }, 1000);

  holder.addEventListener("countdown:destroy", () => window.clearInterval(intervalId), { once: true });
};

export const initEkCountdown = (root: ParentNode | Document = document) => {
  const holders = root.querySelectorAll?.<HTMLElement>("[data-ek-countdown]");
  if (!holders?.length) return;

  for (const holder of Array.from(holders)) {
    initHolder(holder);
  }
};
